export const PHONE_REGEX = /^(?:\(\d{3}\)\s?|\d{3}[-\s]?)\d{3}[-\s]?\d{4}$/;

export const HTML_ESCAPE_REGEX = /[&<>"']/g;

export const DOUBLE_QUOTE_REGEX = /"/g;

// Standard 17-character VIN (excludes I, O, Q) — matches legacy's validateVin exactly.
export const VIN_REGEX = /^[A-HJ-NPR-Za-hj-npr-z\d]{8}[\dX][A-HJ-NPR-Za-hj-npr-z\d]{2}\d{6}$/;

export const POSTAL_CODE_REGEX = /(^\d{5}$)|(^\d{5} - \d{4}$)/;

export const DIGITS_ONLY_REGEX = /^\d+$/;

export const NON_DIGITS_REGEX = /\D/g;

export const FILE_EXTENSION_REGEX = /\.[^/.]+$/;

export const LEADING_DOT_REGEX = /^\./;

export const LEADING_COMMA_REGEX = /^, /;

export const ISO_UTC_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/;

export const ISO_UTC_DATE_TIME_REGEX = /^(\d{4})-(\d{2})-(\d{2})T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|[+-]\d{2}:?\d{2})?$/;

export const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export const PHONE_WITH_EXTENSION_REGEX = /^(?:\(\d{3}\)\s?|\d{3}[-\s]?)\d{3}[-\s]?\d{4}(?:\s*(?:ext\.?|x|#)\s*\d+)?$/i;
